// extracted by mini-css-extract-plugin
module.exports = {"section":"Streams_section__85Pvq"};